import {put, takeLatest, call} from 'redux-saga/effects';
import * as extraService from "../../../../services/extraService.js";
import {
    DELETE_EXTRA,
    DELETE_EXTRA_SUCCESS,
    DELETE_EXTRA_ERROR
}
    from "../../../actions/menu/extras";

function* deleteExtraSaga(action) {
    try {
        yield call(extraService.DeleteExtra, action.payload)
        yield put({
            type: DELETE_EXTRA_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: DELETE_EXTRA_ERROR,error: error.data
        });
    }
}


export function* deleteExtraSagaWatcher() {
    yield takeLatest(DELETE_EXTRA, deleteExtraSaga);
}